(() => {
  if (window.luxoCollectionDescriptionLazy) return;
  window.luxoCollectionDescriptionLazy = true;

  const intentEvents = ['pointerenter', 'focusin', 'touchstart'];

  function findRoot(element) {
    return element?.closest?.('[data-collection-description-lazy]');
  }

  function loadDescription(root) {
    if (!root) return Promise.resolve(null);
    if (root.dataset.collectionDescriptionLoaded === 'true') return Promise.resolve(root);
    if (root.collectionDescriptionLoadPromise) return root.collectionDescriptionLoadPromise;

    const target = root.querySelector('[data-collection-description-full-content]');
    const url = root.dataset.collectionDescriptionUrl;
    if (!target || !url) return Promise.resolve(root);

    root.dataset.collectionDescriptionLoading = 'true';
    root.collectionDescriptionLoadPromise = fetch(url, { credentials: 'same-origin' })
      .then((response) => {
        if (!response.ok) throw new Error(`Unable to load collection description: ${response.status}`);
        return response.text();
      })
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fragment = doc.querySelector('[data-collection-description-fragment]');
        if (!fragment) throw new Error('Collection description fragment was not found.');

        target.innerHTML = fragment.innerHTML.trim();
        root.dataset.collectionDescriptionLoaded = 'true';
        return root;
      })
      .catch((error) => {
        console.warn(error);
        root.dataset.collectionDescriptionError = 'true';
        return root;
      })
      .finally(() => {
        root.dataset.collectionDescriptionLoading = 'false';
      });

    return root.collectionDescriptionLoadPromise;
  }

  function showDescription(root, trigger) {
    const fullDescription = root.querySelector('.collection-description-full');
    const shortDescription = root.querySelector('.collection-description-short');
    const openButton = root.querySelector('[data-collection-description-open]');
    const closeButton = root.querySelector('[data-collection-description-close]');
    const content = root.querySelector('[data-collection-description-full-content]');

    if (!fullDescription || !shortDescription || !content?.innerHTML.trim()) return;

    shortDescription.style.display = 'none';
    fullDescription.style.display = 'block';
    openButton?.setAttribute('aria-expanded', 'true');
    closeButton?.setAttribute('aria-expanded', 'true');

    if (trigger?.matches?.('[data-collection-description-open]')) {
      closeButton?.focus?.({ preventScroll: true });
    }
  }

  function hideDescription(root) {
    const fullDescription = root.querySelector('.collection-description-full');
    const shortDescription = root.querySelector('.collection-description-short');
    const openButton = root.querySelector('[data-collection-description-open]');
    const closeButton = root.querySelector('[data-collection-description-close]');

    if (!fullDescription || !shortDescription) return;

    fullDescription.style.display = 'none';
    shortDescription.style.display = 'block';
    openButton?.setAttribute('aria-expanded', 'false');
    closeButton?.setAttribute('aria-expanded', 'false');
    openButton?.focus?.({ preventScroll: true });
  }

  function bindRoot(root) {
    if (root.dataset.collectionDescriptionBound === 'true') return;
    root.dataset.collectionDescriptionBound = 'true';

    intentEvents.forEach((eventName) => {
      root.addEventListener(eventName, () => loadDescription(root), { once: true, passive: true });
    });
  }

  function bindAll() {
    document.querySelectorAll('[data-collection-description-lazy]').forEach(bindRoot);
  }

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-collection-description-open]');
    if (openButton) {
      event.preventDefault();
      const root = findRoot(openButton);
      loadDescription(root).then(() => showDescription(root, openButton));
      return;
    }

    const closeButton = event.target.closest('[data-collection-description-close]');
    if (closeButton) {
      event.preventDefault();
      hideDescription(findRoot(closeButton));
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll, { once: true });
  } else {
    bindAll();
  }

  window.luxoLoadCollectionDescription = loadDescription;
})();
